module.exports = __webpack_public_path__ + "static/Tom_Thumb_pin_hover-604e2497a0a15d4db7bcb4953f53ea80.png";